import React, { useState, useEffect } from 'react';
import { newsApi } from '../../utils/api';
import PageHeader from '../common/PageHeader';
import ViewToggle from '../common/ViewToggle';
import NewsList from '../common/NewsList';
import LatestNews from '../common/LatestNews';
import AdBanner from '../common/AdBanner';

function CategoryPage({ onOpen, title, catSlug }) {
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [view, setView] = useState('grid');

  useEffect(() => {
    fetchNews();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [catSlug]);

  const fetchNews = async () => {
    setLoading(true);
    try {
      const response = await newsApi.getAll({ category: catSlug, limit: 30 });
      setNews(response.data);
    } catch (error) {
      console.error('Error fetching news:', error);
      setNews([]);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <main className="max-w-[1240px] mx-auto px-5 pt-7 w-full">
        <p className="text-muted py-10">लोड हुँदै...</p>
      </main>
    );
  }

  return (
    <main className="max-w-[1240px] mx-auto px-5 pt-7 pb-[60px] w-full">
      <PageHeader
        title={title}
        subtitle={`"${title}" श्रेणीका ताजा समाचारहरू।`}
        crumbs={['गृहपृष्ठ', 'श्रेणी', title]}
      />

      <div className="flex items-center justify-end gap-4 mb-6">
        <ViewToggle view={view} onChange={setView} />
      </div>

      <div className="grid gap-8 lg:grid-cols-[1fr_340px] items-start">
        <div className="min-w-0">
          <NewsList news={news} view={view} onOpen={onOpen} />
          {news.length === 0 && <p className="text-muted mb-10">यस श्रेणीमा हाल कुनै समाचार छैन।</p>}
        </div>

        <aside className="flex flex-col gap-6 lg:sticky lg:top-24 min-w-0">
          <LatestNews items={news} onOpen={onOpen} />
          <AdBanner label="विज्ञापन" tall position="sidebar" />
        </aside>
      </div>
    </main>
  );
}

export default CategoryPage;